module.exports = __webpack_public_path__ + "static/img/up.42bac6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/up.png
// module id = j3Uq
// module chunks = 4